import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=a27e9360&lang=pug"
import script from "./Open.vue?vue&type=script&lang=js"
export * from "./Open.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports